import './Controls.e5b5cf8722a5c1b4e3e7b77ebb85895d.css';
export default {"gridColumnBlocker":"_gridColumnBlocker_elh2w_1","controls":"_controls_elh2w_1","arrowLeft":"_arrowLeft_elh2w_1"};